import React from 'react';
import { currentYearPeriod, historyYears, performanceDate, previousPeriod, validatePeriod } from './performanceModel';

export default function PerformancePeriod({ period, onChange, dates = [], comparisonPeriod, onComparisonChange, comparison = false }) {
  const error = validatePeriod(period);
  const years = historyYears(dates);
  const suffix = comparison ? ' de comparação' : '';
  function selectHistory(value) {
    if (value === 'current') onChange(currentYearPeriod());
    else if (value === 'previous') {
      const year = Number(currentYearPeriod().start.slice(0, 4)) - 1;
      onChange({ start: `${year}-01-01`, end: `${year}-12-31` });
    } else if (value === 'all') {
      const days = dates.map(performanceDate).filter(day => day && !validatePeriod({ start: day, end: day })).sort();
      onChange({ start: days[0], end: days[days.length - 1] });
    } else if (value) onChange({ start: `${value}-01-01`, end: `${value}-12-31` });
  }
  return <>
    <div className="performance-period" role="group" aria-label={comparison ? 'Período de comparação' : 'Período analisado'}>
    <label>Histórico{suffix}<select aria-label={`Consultar histórico${suffix}`} value="" onChange={event => selectHistory(event.target.value)}>
      <option value="">Escolher período…</option>
      <option value="current">Ano atual (até hoje)</option>
      <option value="previous">Ano anterior completo</option>
      <option value="all" disabled={!years.length}>Todo o histórico disponível</option>
      {years.map(year => <option key={year} value={year}>Ano {year}</option>)}
    </select></label>
    <label>De<input type="date" aria-label={`Início do período${suffix}`} value={period.start} onChange={event => onChange({ ...period, start: event.target.value })} /></label>
    <label>Até<input type="date" aria-label={`Fim do período${suffix}`} value={period.end} onChange={event => onChange({ ...period, end: event.target.value })} /></label>
    {error && <span role="alert">{error}</span>}
    </div>
    {onComparisonChange && <label className="performance-toggle"><input type="checkbox" checked={Boolean(comparisonPeriod)} disabled={Boolean(error) && !comparisonPeriod} onChange={event => onComparisonChange(event.target.checked ? previousPeriod(period) : null)} />Comparar períodos</label>}
    {comparisonPeriod && <PerformancePeriod period={comparisonPeriod} onChange={onComparisonChange} dates={dates} comparison />}
  </>;
}
